import React from "react";

interface Props {
  size?: number;
  color?: string;
}
const CapacityIcon: React.FC<Props> = ({ size = 20, color = "#79808A" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 2.09375H16.25C16.9399 2.09375 17.5 2.65389 17.5 3.34375V15.8438C17.5 16.1753 17.3682 16.4931 17.1338 16.7275C16.8994 16.962 16.5815 17.0938 16.25 17.0938H3.75C3.41848 17.0937 3.10063 16.962 2.86621 16.7275C2.63179 16.4931 2.5 16.1753 2.5 15.8438V3.34375C2.5 2.65389 3.06014 2.09375 3.75 2.09375ZM3.75 2.59375C3.60085 2.59375 3.45628 2.6382 3.33398 2.71973L3.21973 2.81348C3.07907 2.95413 3 3.14484 3 3.34375V15.8438C3 16.2579 3.33586 16.5937 3.75 16.5938H16.25C16.4489 16.5938 16.6396 16.5147 16.7803 16.374C16.9209 16.2334 17 16.0427 17 15.8438V3.34375C17 3.1946 16.9556 3.05003 16.874 2.92773L16.7803 2.81348L16.666 2.71973C16.5437 2.6382 16.3992 2.59375 16.25 2.59375H3.75Z"
        fill={color}
        stroke={color}
      />
      <path d="M3 6.59375H17" stroke={color} stroke-width="1.5" />
      <path d="M5 10.5938L15 10.5938" stroke={color} stroke-linecap="round" />
      <path d="M5 13.5938L15 13.5938" stroke={color} stroke-linecap="round" />
    </svg>
  );
};

export default CapacityIcon;
